<template>
  <EmptyLayout>
    <Header />

    <div class="ma-2 px-2 py-4 white rounded d-flex flex-column">
      <div class="px-2">
        <div style="font-size: 20px;">
          Up to four pros may contact you.
        </div>
        <div class="mt-2" style="font-size: 14px; line-height: 1.25">
            Please give pros 2-3 days to reach out.
        </div>

        <div class="mt-3" style="font-style: italic; font-size: 12px;">
          Click here to <router-link :to="{ name: 'link', replace: true }">make another request</router-link>, or re-scan the QR code to start again
          from the beginning.
        </div>
      </div>

      <div class="mt-3" style="position: relative">
        <v-img src="@/assets/wizard/share-w-friend-686x369.png" />
        <div class="ct white--text text-center">
          <div class="mt-7 font-weight-bold" style="font-size: 18px">
            Share with a Friend!
          </div>

          <div class="mt-2" style="font-size: 16px; line-height: 1.25; font-weight: 500;">
            Help someone else<br/>
            find their next pro.
          </div>
        </div>
        <navigator-share class="cb"
          :url="url"
          title="Find a contractor with Referra"
          text="I'm using Referra to find a contractor, hassle free.  I thought you might like this."
        >
          <template #clickable>
            <v-btn small color="primary">Share Now</v-btn>
          </template>
        </navigator-share>
      </div>

    </div>
  </EmptyLayout>
</template>

<script>

import { EmptyLayout } from '@/layouts'
import Header from './Header'
import NavigatorShare from 'vue-navigator-share'

export default {
  name: 'QRConfirmationView',

  components: { EmptyLayout, Header, NavigatorShare },

  data: () => ({
    timer: null,
  }),

  computed: {
    url: () => window.location.origin,
  },

  mounted() {
    this.timer = setTimeout(() => { 
      console.log('restart after 1 min.')
      this.$router.replace({ name: 'link' })
    }, 1 * 60 * 1000)
  },

  destroyed() {
    if (this.timer) { 
      clearTimeout(this.timer)
      this.timer = null
    }
  },
}
</script>

<style scoped>
  .ct {
    position: absolute;
    top: 0;
    left: 50%;
    width: 100%;
    transform: translateX(-50%);
  }
  .cb {
    position: absolute;
    left: 50%;
    bottom: 32px;
    transform: translateX(-50%);
  }
</style>